import { useCallback, useRef } from "react";

import { usePortal } from "../GeneralServices/PortalService";
import { useAlert } from "../Alerts/withAlert";
import AuthenticationUnlockForm from "./AuthenticationUnlockForm";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";

export const useUnlockForm = () => {
  const { showAlert } = useAlert();
  const { showPortal, hidePortal } = usePortal();

  const portalIndexRef = useRef();

  const hideUnlockForm = useCallback(() => {
    if (portalIndexRef.current) {
      hidePortal(portalIndexRef.current);
      portalIndexRef.current = null;
    }
  }, [hidePortal]);

  const handleClosed = useCallback(
    (success, message) => {
      hideUnlockForm();

      if (message) {
        showAlert({
          message,
          type: success ? ALERT_TYPE_SUCCESS : ALERT_TYPE_ERROR
        });
      }
    },
    [hideUnlockForm, showAlert]
  );

  const showUnlockForm = useCallback(
    (email = null) => {
      portalIndexRef.current = showPortal(
        <AuthenticationUnlockForm email={email} onClose={handleClosed} />
      );
    },
    [handleClosed, showPortal]
  );

  return { showUnlockForm, hideUnlockForm };
};
